import http from "@/utils/axios";
import { notify } from "@kyvg/vue3-notification";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    currentUser: null,
    billingData: null,
    errors: [],
    stats: {
      referrals: {
        issued: 0,
        paid: 0,
        canceled: 0,
        completed: 0,
      },
      commission: 0,
    },
    toPay: 0,
    doctorDashboardStats: null,
  },
  getters: {
    getCurrentUser: (state) => state.currentUser,
    getCurrentUserStats: (state) => state.stats,
    getCurrentUserRole: (state) => state.currentUser?.role,
    getCurrentUserAccountType: (state) => state.currentUser?.account_type,
    getCurrentUserVerified: (state) => state.currentUser.sms_verified,
    getCurrentUserFacility: (state) => state.currentUser?.has_selected_facility,
    getCurrentUserSelectedFacility: (state) =>
      state.currentUser.selected_facility,
    getCurrentUserStatus: (state) => state.currentUser.status,
    isCurrentUserActive: (state) => state.currentUser.status === "active",
    getCurrentUserCommissionPercent: (state) =>
      state.currentUser.commission_percent,
    getCurrentUserBillingData: (state) => state.billingData,
    getErrors: (state) => state.errors,
    getToPay: (state) => state.toPay,
    getHasBillingData: (state) => state.currentUser.has_billing_data,
    getDoctorDashboardStats: (state) => state.doctorDashboardStats,
    getAccountType: (state) => state.currentUser.account_type,
    getUserMedicalCategories: (state) => state.currentUser.medical_categories,
    getUserClinic: (state) => state.currentUser?.clinic,
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    updateCurrentUser(state, userData) {
      state.currentUser = { ...state.currentUser, ...userData };
    },
    setDoctorDashboardStats(state, stats) {
      state.doctorDashboardStats = stats;
    },
    setUserBillingData(state, billingData) {
      state.billingData = billingData;
    },
    setCurrentUserStats(state, stats) {
      state.stats = stats;
    },
    setCurrentUserCommissionPercent(state, percent) {
      state.currentUser.commission_percent = percent;
    },
    setUserStats(state, stats) {
      state.stats = stats;
    },
    setUserToPay(state, toPay) {
      state.toPay = toPay;
    },
    resetCurrentUser(state) {
      state.currentUser = null;
      state.billingData = null;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    clearErrors(state) {
      state.errors = [];
    },
    setUserMedicalCategories(state, payload) {
      state.currentUser.medical_categories = payload;
      state.currentUser.main_medical_category = payload.find(
        (element) => element.is_main == true
      )?.name;
    },
    setUserClinic(state, payload) {
      state.currentUser.clinic = payload;
    },
    setUserEmailVerified(state) {
      if (state.currentUser) state.currentUser.email_verified = true;
    },
    setUserSmsVerified(state) {
      if (state.currentUser) state.currentUser.sms_verified = 1;
    },
  },
  actions: {
    async fetchCurrentUser({ commit }) {
      const response = await http.get("/user");
      const user = response.data.user;
      commit("setCurrentUser", user);
      commit("billingData/setCheckAll", false, { root: true });
      if (user.billing_data) {
        commit("setUserBillingData", user.billing_data);
        commit("billingData/setBillingData", user.billing_data, { root: true });
      }
      if (user.role === "doctor") {
        commit("setUserStats", response.data.stats);
        commit(
          "cart/setPatientDiscountPercent",
          user.patient_discount_percent,
          { root: true }
        );
      }
    },
    async updateCurrentUser({ commit }, user) {
      await http
        .post(`/profile/update`, user)
        .then((response) => {
          const user = response.data.user;
          commit("setCurrentUser", user);
          commit("clearErrors");
          store.commit("modals/closeModal", "updateUserData");
          notify({
            type: "success",
            text: "messages.edit.success",
            duration: 5000,
          });
        })
        .catch(({ response }) => {
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
          }
        });
    },
    async updateCurrentUserProfle({ commit }, user) {
      await http
        .put(`/doctor/update-profile`, user)
        .then((response) => {
          const user = response.data;
          commit("setCurrentUser", user);
          commit("clearErrors");
          store.commit("modals/closeModal", "updateUserData");
          notify({
            type: "success",
            text: "messages.edit.success",
            duration: 5000,
          });
        })
        .catch(({ response }) => {
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
          }
        });
    },
    async updateCurrentUserShowProfile({ commit }, data) {
      await http
        .put(`/doctor/show-profile`, data)
        .then(({ data }) => {
          commit("clearErrors");
          notify({
            type: "success",
            text: "messages.edit.success",
            duration: 5000,
          });
          commit("updateCurrentUser", { show_profile: data.show_profile });
        })
        .catch(({ response }) => {
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
          }
        });
    },
    async fetchUserStats({ commit }, params) {
      await http
        .get("/doctor/stats", {
          params: params,
        })
        .then(({ data }) => {
          commit("setCurrentUserStats", data.stats);
        });
    },
    async fetchDoctorStats({ commit }) {
      const { data } = await http.get("/doctor/dashboard-stats");
      commit("setDoctorDashboardStats", data);
    },
  },
};
